import React from 'react';
import { motion } from 'framer-motion';
import galleryImage1 from '../style/images/ficci_Flo_event_ITC.jpeg';
import galleryImage2 from '../style/images/col_3.jpeg';
import galleryImage3 from '../style/images/birthDay_Event3.jpeg';
import galleryImage4 from '../style/images/birthDay_Event4.jpeg';
import galleryImage5 from '../style/images/Vgn Grandeur2.jpeg';
import galleryImage6 from '../style/images/Gro_driveEvent.jpeg';
// import galleryImage7 from '../style/images/col_1.jpeg';
// import galleryImage8 from '../style/images/Gro_driveEvent2.jpeg';
import galleryImage9 from '../style/images/Dbs_bank_standup_comedy2.jpeg';
import galleryImage01 from '../style/images/Gro_driveEvent1.jpeg';
import galleryImage02 from '../style/images/Dbs_bank_standup_comedy3.jpeg';
import galleryImage03 from '../style/images/Dbs_bank_standup_comedy1.jpeg';
import galleryImage04 from '../style/images/Dbs_bank_standup_comedy4.jpeg';
import galleryImage05 from '../style/images/Dbs_bank_standup_comedy5.jpeg';
import galleryImage10 from '../style/images/gallery10.jpeg';
import galleryImage11 from '../style/images/IMP06643.JPG';
import galleryImage12 from '../style/images/IMP06670.JPG';
import galleryImage13 from '../style/images/IMP06675.JPG';
import galleryImage14 from '../style/images/IMP06687.JPG';
import galleryImage15 from '../style/images/IMP06751.JPG';
import galleryImage17 from '../style/images/IMP06819.JPG';
import galleryImage18 from '../style/images/IMP07041.JPG';
import galleryImage19 from '../style/images/IMP07366.JPG';
import galleryImage20 from '../style/images/IMP07687.JPG';
import galleryImage21 from '../style/images/IMP07706.JPG';
// import galleryImage22 from '../style/images/gallery22.jpeg';
// import galleryImage23 from '../style/images/gallery23.jpeg';
// import galleryImage24 from '../style/images/gallery24.jpeg';
// import galleryImage25 from '../style/images/gallery25.jpeg';
// import galleryImage26 from '../style/images/gallery26.jpeg';
// import galleryImage27 from '../style/images/gallery27.jpeg';
// import galleryImage28 from '../style/images/gallery28.jpeg';





const images = [
  galleryImage1,
  // galleryImage2,
  // galleryImage3,
  // galleryImage4,
  galleryImage5,
  galleryImage6,
  // galleryImage7,
  // galleryImage8,
  galleryImage9,
  // galleryImage01,
  galleryImage02,
  galleryImage03,
  galleryImage04,
  galleryImage05,
  galleryImage10,
  galleryImage11,
  galleryImage12,
  galleryImage13,
  galleryImage14,
  galleryImage15,
  galleryImage17,
  galleryImage18,
  galleryImage19,
  galleryImage20,
  galleryImage21,
  // galleryImage22,
  // galleryImage23,
  // galleryImage24,
  // galleryImage25,
  // galleryImage26,
  // galleryImage27,
  // galleryImage28,
];

const Gallery = () => {
  return (
    <section id="gallery" className="gallery-section">
      <div className="container">
        <motion.h2
          className="gallery-title"
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          viewport={{ once: true }}
        >
          Our Gallery
          <div className="section-divider"></div>
        </motion.h2>

        <div className="gallery-masonry">
          {images.map((src, index) => (
            <motion.div
              key={index}
              className="masonry-item"
              whileHover={{ scale: 1.03 }}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.4, delay: index * 0.1 }}
              viewport={{ once: true }}
            >
              <img src={src} alt={`Gallery ${index + 1}`} loading="lazy" />
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Gallery;
